import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Workflow from "@/pages/Workflow";
import Growth from "@/pages/Growth";
import Product from "@/pages/Product";
import Pricing from "@/pages/Pricing";
import Audit from "@/pages/Audit";
import Labs from "@/pages/Labs";
import LabsPost from "@/pages/LabsPost";
import IndustryPage from "@/pages/IndustryPage";
import Gallery from "@/pages/Gallery";
import CreativeProject from "@/pages/CreativeProject";
import About from "@/pages/About";
import OurBrands from "@/pages/OurBrands";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Customers from "@/pages/Customers";
import Admin from "@/pages/Admin";
import { INDUSTRIES } from "@/data/industries";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/workflow" element={<Workflow />} />
            <Route path="/engineering" element={<Navigate to="/workflow" replace />} />
            <Route path="/growth" element={<Growth />} />
            <Route path="/product" element={<Product />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/growth/portfolio" element={<Navigate to="/gallery" replace />} />
            <Route path="/marketing" element={<Navigate to="/growth" replace />} />
            <Route path="/creative" element={<Navigate to="/growth" replace />} />
            <Route path="/creative/:slug" element={<CreativeProject />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/labs" element={<Labs />} />
            <Route path="/labs/:slug" element={<LabsPost />} />
            <Route path="/work" element={<Customers />} />
            {Object.entries(INDUSTRIES).map(([key, data]) => (
              <Route
                key={key}
                path={data.route}
                element={<IndustryPage industry={data} />}
              />
            ))}
            <Route path="/about" element={<About />} />
            <Route path="/our-brands" element={<OurBrands />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
